(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-anchor-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.RDTabbedContentLoader) return;
  window.RDTabbedContentLoader = true;
  var loading = null;
  function initialize(scope) {
    if (window.RDTabbedContent) {
      window.RDTabbedContent.initAll(scope);
      return;
    }
    var root = scope.matches && scope.matches('[data-rd-tabbed-content]') ? scope : scope.querySelector('[data-rd-tabbed-content]');
    if (!root || loading || !root.dataset.rdtcScriptUrl) return;
    loading = document.createElement('script');
    loading.src = root.dataset.rdtcScriptUrl;
    loading.async = true;
    loading.onload = function () {
      loading = null;
      if (window.RDTabbedContent) window.RDTabbedContent.initAll(document);
    };
    loading.onerror = function () {
      loading.remove();
      loading = null;
    };
    document.head.appendChild(loading);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-order-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.RDOrderFaqProReady) return;
    window.RDOrderFaqProReady = true;

    function normalizeSingleOpen(section) {
      if (!section || section.getAttribute('data-single-open') !== 'true') return;
      var openItems = section.querySelectorAll('[data-rd-faq-item][open]');
      openItems.forEach(function (item, index) {
        if (index > 0) item.removeAttribute('open');
      });
    }

    function initialize(root) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('[data-rd-order-faq]')) normalizeSingleOpen(scope);
      scope.querySelectorAll('[data-rd-order-faq]').forEach(normalizeSingleOpen);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('toggle', function (event) {
      var item = event.target;
      if (!item || !item.matches || !item.matches('[data-rd-faq-item]') || !item.open) return;

      var section = item.closest('[data-rd-order-faq]');
      if (!section || section.getAttribute('data-single-open') !== 'true') return;

      section.querySelectorAll('[data-rd-faq-item][open]').forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
    }, true);

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (!block) return;

      var item = block.matches && block.matches('[data-rd-faq-item]')
        ? block
        : block.querySelector && block.querySelector('[data-rd-faq-item]');

      if (item) item.setAttribute('open', '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-rich-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.RDRichTextPro) return;

  const state = new WeakMap();

  const measureReadMore = (button, target) => {
    const expanded = button.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      button.hidden = false;
      return;
    }

    target.classList.add('rd-rich-text__content--cut-off');
    const collapsedHeight = target.getBoundingClientRect().height;

    target.classList.remove('rd-rich-text__content--cut-off');
    const fullHeight = target.getBoundingClientRect().height;

    const isOverflowing = fullHeight > collapsedHeight + 1;
    button.hidden = !isOverflowing;

    if (isOverflowing) {
      target.classList.add('rd-rich-text__content--cut-off');
    }
  };

  const initRoot = (root) => {
    if (!root || state.has(root)) return;

    root.classList.add('is-js-ready');

    const cleanup = [];
    const readMorePairs = [];
    let resizeFrame = 0;

    const refreshReadMore = () => {
      readMorePairs.forEach(({ button, target }) => measureReadMore(button, target));
    };

    const scheduleReadMoreRefresh = () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        refreshReadMore();
      });
    };

    root.querySelectorAll('.js-rd-rich-text-read-more').forEach((button) => {
      const targetId = button.getAttribute('aria-controls');
      const target = targetId ? document.getElementById(targetId) : null;

      if (!target) {
        button.hidden = true;
        return;
      }

      readMorePairs.push({ button, target });

      const onClick = () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const willExpand = !expanded;

        button.setAttribute('aria-expanded', String(willExpand));
        target.classList.toggle('rd-rich-text__content--cut-off', !willExpand);

        const label = button.querySelector('[data-text]');
        if (label) {
          label.textContent = willExpand
            ? button.getAttribute('data-show-less-text')
            : button.getAttribute('data-read-more-text');
        }
      };

      button.addEventListener('click', onClick);
      cleanup.push(() => button.removeEventListener('click', onClick));
    });

    if (readMorePairs.length) {
      refreshReadMore();

      window.addEventListener('resize', scheduleReadMoreRefresh, { passive: true });
      cleanup.push(() => {
        window.removeEventListener('resize', scheduleReadMoreRefresh);
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
      });

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          if (state.has(root)) scheduleReadMoreRefresh();
        });
      }
    }

    const highlights = root.querySelectorAll(
      '.rd-rich-text__highlight[data-animation]:not([data-animation="none"])'
    );

    if (highlights.length) {
      if (!('IntersectionObserver' in window)) {
        highlights.forEach((element) => element.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.25,
          rootMargin: '0px 0px -5% 0px'
        });

        highlights.forEach((element) => observer.observe(element));
        cleanup.push(() => observer.disconnect());
      }
    }

    state.set(root, cleanup);
  };

  const destroyRoot = (root) => {
    const cleanup = state.get(root);
    if (!cleanup) return;
    cleanup.forEach((fn) => fn());
    root.classList.remove('is-js-ready');
    state.delete(root);
  };

  const initWithin = (scope = document) => {
    if (scope.matches?.('[data-rd-rich-text]')) initRoot(scope);
    scope.querySelectorAll?.('[data-rd-rich-text]').forEach(initRoot);
  };

  const initAll = () => initWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-rd-rich-text]').forEach(destroyRoot);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const button = block.querySelector?.('.js-rd-rich-text-read-more');
    if (!button || button.hidden || button.getAttribute('aria-expanded') === 'true') return;

    button.setAttribute('aria-expanded', 'true');
    const targetId = button.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;
    target?.classList.remove('rd-rich-text__content--cut-off');

    const label = button.querySelector('[data-text]');
    if (label) label.textContent = button.getAttribute('data-show-less-text');
  });

  window.RDRichTextPro = { initWithin, destroyRoot };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-welcome-gift"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function legacyCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(textarea);
      return copied;
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rd-copy-code]');
      if (!button) return;

      var code = button.getAttribute('data-rd-copy-code') || '';
      if (!code) return;

      var originalLabel = button.getAttribute('data-rd-original-label') || button.textContent.trim();
      var successLabel = button.getAttribute('data-rd-copy-success') || 'Copied';
      button.setAttribute('data-rd-original-label', originalLabel);

      var onSuccess = function () {
        button.textContent = successLabel;
        window.setTimeout(function () {
          if (button.isConnected) button.textContent = originalLabel;
        }, 1800);
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(onSuccess).catch(function () {
          if (legacyCopy(code)) onSuccess();
        });
      } else if (legacyCopy(code)) {
        onSuccess();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
